import { render, staticRenderFns } from "./menuNameDialog.vue?vue&type=template&id=fb3796ac"
import script from "./menuNameDialog.vue?vue&type=script&lang=js"
export * from "./menuNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb3796ac')) {
      api.createRecord('fb3796ac', component.options)
    } else {
      api.reload('fb3796ac', component.options)
    }
    module.hot.accept("./menuNameDialog.vue?vue&type=template&id=fb3796ac", function () {
      api.rerender('fb3796ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/editor/nav/menuNameDialog.vue"
export default component.exports